import { useEffect, useState, Fragment, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Progress from '../../../components/Progress';
import Button from '../../../components/Button';
import { ChevronLeft } from 'react-feather';
import { useWizard } from '../../../hooks/useWizard';
import { RoutePaths } from '../../../config/routes';
import { useReassurance } from '../../../hooks/useReassurance';
import StepWrapper from '../../../components/Step/Wrapper';
import FormLayout from '../../../components/Step/FormLayout';
import FormGrid from '../../../components/Step/FormGrid';
import FormCol from '../../../components/Step/FormCol';
import ReassuranceWrapper from '../../../components/Reassurance/Wrapper';
import StepHeader from '../../../components/Navigation/StepHeader';
import ScrollToTop from '../../../components/ScrollToTop';
import Seo from '../../../components/Seo';
var SignUpProfessional = function () {
    var _a, _b;
    var state = useLocation().state;
    var navigate = useNavigate();
    var _c = useWizard(), getWizard = _c.getWizard, getPreviousStep = _c.getPreviousStep, clearWizard = _c.clearWizard;
    var reassurances = useReassurance().reassurances;
    var _d = useState(false), ready = _d[0], setReady = _d[1];
    var stepRef = useRef(null);
    var reassuranceRef = useRef(null);
    useEffect(function () {
        if ((state === null || state === void 0 ? void 0 : state.from) === RoutePaths.SIGN_IN_SITUATION) {
            var savedState = getWizard();
            if (savedState) {
                var shouldPreFill = window.confirm('On dirait que vous avez déjà commencé à remplir le formulaire. Souhaitez-vous reprendre là où vous en étiez ?');
                if (!shouldPreFill) {
                    clearWizard();
                }
                else {
                    navigate(savedState.lastStep.path);
                }
            }
        }
        setReady(true);
    }, []);
    return (<div className="flex w-full flex-col lg:h-screen">
      <Seo title="Créer un compte professionnel"/>
      <StepHeader />
      <StepWrapper>
        <FormLayout ref={stepRef}>
          <ScrollToTop wrapper={stepRef}/>
          <FormGrid className="mb-10 lg:mb-20">
            <div className="items-center pt-10 lg:col-span-12 lg:grid lg:grid-cols-12 max-lg:flex">
              <Button type="inline" icon={ChevronLeft} side="start" className="mr-auto flex-1 text-gray-500 xl:col-span-2 max-lg:flex-none" to={(_a = getPreviousStep()) === null || _a === void 0 ? void 0 : _a.path}>
                <span className="max-sm:hidden lg:max-xl:hidden">Précédent</span>
              </Button>
              <Progress />
            </div>
            <FormCol>{ready && <Outlet context={{ values: (_b = getWizard()) === null || _b === void 0 ? void 0 : _b.values }}/>}</FormCol>
          </FormGrid>
        </FormLayout>
        <ReassuranceWrapper ref={reassuranceRef}>
          <ScrollToTop wrapper={reassuranceRef}/>
          {reassurances &&
            reassurances.map(function (reassurance, index) { return (<Fragment key={index}>{reassurance}</Fragment>); })}
        </ReassuranceWrapper>
      </StepWrapper>
    </div>);
};
export default SignUpProfessional;
